import { PluginEnsureId } from './PluginEnsureId';
import { PluginEnsureEditElementInView } from './PluginEnsureEditElementInView';
import { PluginLectioSlide } from './PluginLectioSlide';
import { PluginLectioTexMath } from './PluginLectioTexMath';
import { PluginCommentBlock2 } from './PluginCommentBlock2';
import { PluginLectioPasteHelper } from './PluginLectioPasteHelper';
import { PluginOpenLink } from './PluginOpenLink';
import { PluginLectioButtons } from './PluginLectioButtons';
import { PluginFixedToolbar } from './PluginFixedToolbar';
import { PluginLectioLink } from './PluginLectioLink';
import { PluginLectioImage } from './PluginLectioImage';
import { PluginLectioEmbed } from './PluginLectioEmbed';
import { PluginLectioMobileToolbar } from './PluginLectioMobileToolbar';
import { PluginLectioAudio } from './PluginLectioAudio';
import { PluginLectioAudioRecord } from './PluginLectioAudioRecord';
import { PluginAttachedFile } from './PluginAttachedFile';
import './PluginLectioAutoLink';
import { PluginLectioContent } from './PluginLectioContent';
import { PluginHeadingShortcuts } from './PluginHeadingShortcuts';
import { PluginToolbarShortcutsDisplay } from './PluginToolbarShortcutsDisplay';
import { PluginLectioPlaceholderHtml } from './PluginLectioPlaceholderHtml';
import { PluginDisableAutoUrlDetect } from './PluginDisableAutoUrlDetect';
import { PluginMathJaxRequiredContentFix } from './PluginMathJaxRequiredContentFix';
import { PluginSetFocusWidgetFix } from './PluginSetFocusWidgetFix';

export class LCDocumentEditorPluginManager {
	public static Init(): void {
		new PluginEnsureId().Init();
		new PluginEnsureEditElementInView().Init();
		new PluginLectioSlide().Init();
		new PluginLectioTexMath().Init();
		new PluginCommentBlock2().Init();
		new PluginLectioPasteHelper().Init();
		new PluginOpenLink().Init();
		new PluginLectioButtons().Init();
		new PluginFixedToolbar().Init();
		new PluginLectioLink().Init();
		new PluginLectioImage().Init();
		new PluginLectioEmbed().Init();
		new PluginLectioAudio().Init();
		new PluginLectioAudioRecord().Init();
		new PluginLectioMobileToolbar().Init();
		new PluginAttachedFile().Init();
		new PluginLectioContent().Init();
		new PluginHeadingShortcuts().Init();
		new PluginToolbarShortcutsDisplay().Init();
		new PluginLectioPlaceholderHtml().Init();
		new PluginDisableAutoUrlDetect().Init();
		new PluginMathJaxRequiredContentFix().Init();
		new PluginSetFocusWidgetFix().Init();
	}
}
